import React from 'react';
import 'katex/dist/katex.min.css';
import { InlineMath, BlockMath } from 'react-katex';

type Props = {
  text?: string | null;
  block?: boolean;
  style?: React.CSSProperties;
};

// Simple renderer that supports $...$ (inline) and $$...$$ (block)
const LatexText: React.FC<Props> = ({ text, block = false, style }) => {
  if (!text) return null;

  // First, split by block math $$...$$
  const blockRegex = /\$\$([\s\S]*?)\$\$/g;
  const parts: Array<{ type: 'text' | 'block'; content: string }> = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  while ((match = blockRegex.exec(text)) !== null) {
    const [full, content] = match;
    const start = match.index;
    if (start > lastIndex) {
      parts.push({ type: 'text', content: text.slice(lastIndex, start) });
    }
    parts.push({ type: 'block', content });
    lastIndex = start + full.length;
  }
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.slice(lastIndex) });
  }

  const renderInline = (s: string, idxBase: number) => {
    const inlineRegex = /\$([^$]+?)\$/g;
    const nodes: React.ReactNode[] = [];
    let li = 0;
    let m: RegExpExecArray | null;
    while ((m = inlineRegex.exec(s)) !== null) {
      const [full, content] = m;
      const st = m.index;
      if (st > li) {
        nodes.push(<span key={`t-${idxBase}-${st}`}>{s.slice(li, st)}</span>);
      }
      nodes.push(<InlineMath key={`i-${idxBase}-${st}`}>{content}</InlineMath>);
      li = st + full.length;
    }
    if (li < s.length) {
      nodes.push(<span key={`t-${idxBase}-end`}>{s.slice(li)}</span>);
    }
    return nodes;
  };

  return (
    <div style={style}>
      {parts.map((p, i) =>
        p.type === 'block' ? (
          <BlockMath key={`b-${i}`}>{p.content}</BlockMath>
        ) : (
          <span key={`s-${i}`}>{renderInline(p.content, i)}</span>
        )
      )}
      {block && <></>}
    </div>
  );
};

export default LatexText;
